import axiosInstance from './axiosInstance';
import { clearCache } from '../utils/lookupCache';

const API_URL = process.env.REACT_APP_API_URL;
const API_ROOT = API_URL?.endsWith('/api') ? API_URL : `${API_URL}/api`;

// GET all hierarchyStructures
export const getHierarchyStructures = async () => {
  try {
    const response = await axiosInstance.get(`${API_ROOT}/hierarchy-structures`);
    return response.data;
  } catch (error) {
    console.error("Error fetching hierarchyStructures:", error.response?.data || error);
    throw error;
  }
};

// GET a single hierarchyStructure
export const getHierarchyStructureById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_ROOT}/hierarchy-structures/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching hierarchyStructure:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new hierarchyStructure
export const createHierarchyStructure = async (hierarchyStructureData) => {
  try {
    const response = await axiosInstance.post(`${API_ROOT}/hierarchy-structures`, hierarchyStructureData);
    clearCache('hierarchy-structures');
    return response.data;
  } catch (error) {
    console.error("Error creating hierarchyStructure:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing hierarchyStructure
export const updateHierarchyStructure = async (id, hierarchyStructureData) => {
  try {
    const response = await axiosInstance.put(`${API_ROOT}/hierarchy-structures/${id}`, hierarchyStructureData);
    clearCache('hierarchy-structures');
    return response.data;
  } catch (error) {
    console.error("Error updating hierarchyStructure:", error.response?.data || error);
    throw error;
  }
};

// DELETE a hierarchyStructure
export const deleteHierarchyStructure = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_ROOT}/hierarchy-structures/${id}`);
    clearCache('hierarchy-structures');
    return response.data;
  } catch (error) {
    console.error("Error deleting hierarchyStructure:", error.response?.data || error);
    throw error;
  }
};
